import React from 'react'
import Modal from 'react-modal'
import Helmet from 'react-helmet'
import { Link } from 'gatsby'
import Topbar from '../components/topbar'
import Menu from '../components/menu'
import { blogUrl, assetUrl } from '../util/constants'

import '../styles/all.scss'

const description = 'Initialized Capital is a San Francisco based early stage venture capital firm'
const socialImgSquare = assetUrl + 'brand/IC_Badger_01_bg@3x.png'
const fbImage = assetUrl + 'brand/IC_Badger_02_bg-open-graph.png'

class DefaultLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = { menuOpen: false }
  }

  showMenu = () => {
    this.setState({ menuOpen: true })
  }
  hideMenu = () => {
    this.setState({ menuOpen: false })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.key !== nextProps.location.key) {
      this.setState({ menuOpen: false })
    }
  }

  render() {
    const { location: { pathname } } = this.props
    const [_, slug] = pathname.split('/')
    const homepage = slug === ''

    const classes = ['main', slug === '' ? 'index' : slug]
    if (!homepage) {
      classes.push('fixed-bar')
    }

    const childProps = { ...this.props, showMenu: this.showMenu }

    return (
      <div className={classes.join(' ')}>
        <Helmet
          title="Initialized Capital"
          meta={[
            { name: 'description', content: description },
            { name: 'keywords', content: 'venture, capital, seed, Initialized' },

            { property: 'og:title', content: 'Initialized Capital' },
            { property: 'og:type', content: 'website' },
            { property: 'og:description', content: description },
            { property: 'og:image', content: fbImage },
            { property: 'og:site_name', content: 'Initialized Capital' },

            { name: 'twitter:card', value: 'summary' },
            { name: 'twitter:title', value: 'Initialized Capital' },
            { name: 'twitter:description', value: description },
            { name: 'twitter:image', value: socialImgSquare },
            { name: 'twitter:site', value: '@initialized' },
            { name: 'twitter:creator', value: '@initialized' },
          ]}
        >
          <link rel="icon" type="image/png" href="/ic_favicon@2x.png" />

        </Helmet>

        {!homepage && <Topbar current={slug} showMenu={this.showMenu} />}

        <div className="content">
          {React.cloneElement(this.props.children, childProps)}
        </div>

        <footer>
          <ul className="footer-menu">
            <li>
              {slug === 'interests' && <a href="#faq">FAQ</a>}
              {slug !== 'interests' && <Link to="/interests/#faq">FAQ</Link>}
            </li>
            <li>
              <a href="https://twitter.com/Initialized" rel="noreferrer" target="_blank">Twitter</a>
            </li>
            <li>
              <a href="https://www.instagram.com/initialized/" rel="noreferrer" target="_blank">Instagram</a>
            </li>
            <li>
              <a href={blogUrl} target="_blank" rel="noreferrer">Blog</a>
            </li>
            <li>
              <a href="https://jobs.lever.co/initialized" target="_blank" rel="noreferrer">Jobs</a>
            </li>
            <li>
              {!homepage && <Link to="/#newsletter">Sign up for our newsletter</Link>}
              {homepage && <a href="#newsletter">Sign up for our newsletter</a>}
            </li>
          </ul>
          <div className="logo">
            <a href="/" alt="Home" />
          </div>

          <div className="copyright">
            © {new Date().getFullYear()} Initialized Capital Management. Honeybadger logo, "ic()",
            and "initialized()" wordmark are all trademarks of Initialized Capital Management.
            All Rights Reserved.
          </div>
        </footer>

        <Modal
          isOpen={this.state.menuOpen}
          bodyOpenClassName="modal-open"
          portalClassName="modal menu-modal"
          overlayClassName="modal-overlay"
          className="modal-body mobile-menu"
          closeTimeoutMS={200}
        >
          <nav>
            <a className="logo" href="/" alt="Home" />
            <a
              className="close-link" href="javascript:void(0);" onClick={this.hideMenu.bind(this)}
            >
              Close
            </a>
            <Menu current={slug} />
          </nav>
        </Modal>
      </div>
    )
  }
}

export default DefaultLayout
